
 define('modules/application/wizard/classes/logicAreas',[
  "app",

  // Libs
  "backbone",

  // Classes
  "./genericCollectionSection"

],

function(app, Backbone, genericCollectionSection) {
  var eventsToBind          = _.extend({}, genericCollectionSection.genericCollectionItem.View.prototype.events);
  var genericCollectionItem = _.extend({}, genericCollectionSection.genericCollectionItem, {
    View  : genericCollectionSection.genericCollectionItem.View.extend({
      tagName   : "li",
      className : "logicArea",
      template  : "application/wizard/sections/genericCollectionSection/logicArea",
      events    : _.extend(eventsToBind, {
        "click"                            :  "itemClickedEventHandler",
        "change .type"                     :  "typeChangedEventHandler",
        "change .accessory"                :  "accessoryChangedEventHandler",
        "keyup input[name='description']"  :  "descriptionChangedEventHandler"
      }),

      serialize                         : function()  {
        return {model:this.model, app:app};
      },

      initialize                        : function()  {
        this.model.bind("render:requested",   this.render, this);
        this.model.bind("updateViews",        this.render, this);
        this.model.bind("change:number",      this.render, this);
      },

      itemClickedEventHandler           : function() {
        this.model.set("selected", true);
      },

      typeChangedEventHandler           : function(e) {
        var typePackageClassId      = e.currentTarget.value;

        //Update the model
        this.model.setPackageClassId(typePackageClassId);
      },

      accessoryChangedEventHandler      : function(e)  {
        if (e.currentTarget.value)
        {
          var accessoryPackageClassId = e.currentTarget.value;

          //Update the model
          this.model.setAccessory(accessoryPackageClassId);
        }
      },

      descriptionChangedEventHandler    : function(e) {
        this.model.set("description", e.currentTarget.value);
      },

      afterRender                       : function()  {
        this.$el.find("select").removeAttr("rel");
        window.customizeFormElements.call();
      }
    }),
    Model : genericCollectionSection.genericCollectionItem.Model.extend({
      defaults : {
        number      : -1,
        filterId    : -1,
        selected    : false,
        description : ""
      },

      initialize                        : function() {
        var fetchedPackages     = this.get("fetchedPackages"),
            fetchedAccessories  = this.get("fetchedAccessories"),
            accessory           = this.get("accessory"),
            packageClassId         = this.get("packageClassId");

        this.bind("change:selected",    this.selectedStatusChangedEventHandler, this);

        if (!this.get("packageClassId"))
          _.extend(this.attributes, fetchedPackages[0]);
        else
          _.extend(this.attributes,           _.filter(fetchedPackages,    function(iterablePackage) {return (iterablePackage.packageClassId===packageClassId);})[0]);

        if (!accessory)
          this.set("accessory",     fetchedAccessories[0]);
        else
          _.extend(this.attributes.accessory, _.filter(fetchedAccessories, function(iterablePackage) {return (iterablePackage.packageClassId===accessory.packageClassId);})[0]);
      },

      selectedStatusChangedEventHandler : function() {
        if (this.get("selected"))
          this.get("collectionEventAggregator").trigger("selectedItem:changed", this);
        this.trigger("render:requested");
      },

      setAccessory          : function(packageClassId) {
        this.set("accessory", _.filter(this.get("fetchedAccessories"), function(iterablePackage){return iterablePackage.packageClassId===packageClassId;})[0]);
        this.trigger("render:requested");
      },

      enableChangeMode      : function() {
        this.set("changeMode", true);
        this.get("collectionEventAggregator").bind("abilitationToChangeExpansionType:granted",   this.completeTypeChange,  this);
        this.get("collectionEventAggregator").bind("abilitationToChangeExpansionType:refused",   this.revertTypeChange,    this);
      },

      disableChangeMode     : function() {
        this.set("changeMode", false);
        this.get("collectionEventAggregator").unbind("abilitationToChangeExpansionType:granted",   this.completeTypeChange);
        this.get("collectionEventAggregator").unbind("abilitationToChangeExpansionType:refused",   this.revertTypeChange);
      },

      completeTypeChange                : function(packageAttributes) {
        this.set(packageAttributes);
        this.set("futureBonusVde", undefined);
        this.disableChangeMode();
        window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        this.trigger("render:requested");
      },

      revertTypeChange                  : function(packageAttributes) {
        this.set("futureBonusVde", undefined);
        this.disableChangeMode();
        alert("Unable to continue");
        this.trigger("render:requested");
      },

      resetValues                       : function() {
        this.set("catalogId",                undefined);
        this.set("description",              undefined);
        this.set("image",                    undefined);
        this.set("links",                    undefined);
        this.set("mnemonic",                 undefined);
        this.set("optionalPackages",         undefined);
        this.set("packageActuator",          undefined);
        this.set("packageClassId",           undefined);
        this.set("packageClassLabel",        undefined);
        this.set("packageInDepth",           undefined);
        this.set("packageLoad",              undefined);
        this.set("price",                    undefined);
        this.set("productCode",              undefined);
        this.set("productDescription",       undefined);
        this.set("productInDepth",           undefined);
        this.set("productLabel",             undefined);
        this.set("specialVars",              undefined);
        this.set("wizardChoiceDescription",  undefined);
        this.set("wizardChoiceLabel",        undefined);
        this.set("packageClassDescription", undefined);
        this.set("packageClassId",          undefined);
        this.set("packageClassLabel",       undefined);
      },

      deliverCurrent                  : function() {
        var mainProductSpecialVars,
            accessorySpecialVars;

        var sendConsumption        = function(consumption) {
          if (consumption)
          {
            var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

            if (consumption<0)
              consumptionIndicatorModel.addSupplyCurrent(consumption);
            else
              consumptionIndicatorModel.addCurrentConsumption(consumption);
          }
        };

        if (this.get("specialVars"))
        {
          if (!(this.get("specialVars") instanceof Object))
            this.attributes.specialVars = JSON.parse(this.attributes.specialVars);

          if ( (this.get("specialVars").consumptionGroupId) && (this.get("specialVars").groupExtraConsumption) )
          {
            var consumptionGroupId        = this.get("specialVars").consumptionGroupId.toString();
            var groupExtraConsumption     = this.get("specialVars").groupExtraConsumption;
            var maxExtraConsumptions      = BticinoS4B.Instances.Models.ApplicationModel.get("maxExtraConsumption");

            if ( (!maxExtraConsumptions[consumptionGroupId]) || (maxExtraConsumptions[consumptionGroupId]<groupExtraConsumption) )
              maxExtraConsumptions[consumptionGroupId] = groupExtraConsumption;

            BticinoS4B.Instances.Models.ApplicationModel.set("maxExtraConsumption", maxExtraConsumptions);
          }

          if(this.get("specialVars").currentConsumption)
            sendConsumption(this.get("specialVars").currentConsumption);
        }

        if ( this.get("accessory") && this.get("accessory").specialVars)
        {
          if (!(this.get("accessory").specialVars instanceof Object))
            this.attributes.accessory.specialVars = JSON.parse(this.attributes.accessory.specialVars);

          if(this.get("accessory").specialVars.currentConsumption)
            sendConsumption(this.get("accessory").specialVars.currentConsumption);
        }
      }
    })
  });

  var collectionItemModel = genericCollectionItem.Model;
  var collectionModel     = Backbone.Collection.extend({model : collectionItemModel});

  var logicArea           = _.extend({}, genericCollectionSection, {

    Views : {
      titleBar  : genericCollectionSection.Views.titleBar,
      content   : genericCollectionSection.Views.content.extend({

        initialize                      : function() {
          genericCollectionSection.Views.content.prototype.initialize.apply(this);

          //Binding events
          window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen",  this.accessoryLineChosenEventHandler);
          window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen",    this.accessoryLineChosenEventHandler, this);

          this.model.unbind("packages:fetched",               this.packagesFetchedEventHandler);
          this.model.bind("packages:fetched",                 this.packagesFetchedEventHandler, this);
          this.model.bind("updateViews",                      this.render, this);
        },

        packagesFetchedEventHandler     : function() {
          this.$el.find(".loadingSection").hide();
          this.$el.find(".regularSection").show();
          this.render();
        },

        showLoader                      : function() {
          this.$el.find(".regularSection").hide();
          this.$el.find(".loadingSection").show();
        },

        //Event handlers
        accessoryLineChosenEventHandler : function(accessoryLineId) {
          this.showLoader();
          this.model.fetchPackages();
        },

        addItemButtonClickedEventHandler       : function() {
          var collectionItemView  = genericCollectionItem.View;
          var elementToAdd        = this.model.addItem();
          if (elementToAdd) {
            var viewToAdd = new collectionItemView({model : elementToAdd});
            //this.insertView(".elements", viewToAdd);
            this.model.sortItems();
            this.$el.find(".alert").remove();
            viewToAdd.render();
          }
        },

        duplicateItemButtonClickedEventHandler : function() {
          var collectionItemView  = genericCollectionItem.View;
          var elementToAdd        = this.model.duplicateSelectedItem();
          if (elementToAdd) {
            var viewToAdd = new collectionItemView({model : elementToAdd});
            //this.insertView(".elements", viewToAdd);
            this.model.sortItems();
            this.$el.find(".alert").remove();
            viewToAdd.render();
          }
        },

        removeItemButtonClickedEventHandler    : function() {
          var elementToRemove     = this.model.removeSelectedItem();
          var viewToRemove        = this.getView(function(view){return (elementToRemove===view.model);});
          if (viewToRemove) {
            viewToRemove.$el.remove();
            this.model.sortItems();
          }
        },

        beforeRender                           : function() {
          var collection          = this.model.get("collection"),
              collectionLength    = collection ? collection.models.length : 0,
              collectionItemView  = genericCollectionItem.View,
              i                   = 0;

          for (i=0; i<collectionLength; i++)
            this.insertView(".elements", new collectionItemView({model : collection.models[i]}));
        },

        afterRender                            : function() {
          window.customizeFormElements.call();
        }

      })
    },

    Model                         : genericCollectionSection.Model.extend({
      defaults : _.extend(  {
        name                   : "IDS_WAM8_19",
        collectionEventAggregator : _.extend({}, Backbone.Events)
      }, genericCollectionSection.Model.prototype.defaults),

      initialize        : function()  {
        genericCollectionSection.Model.prototype.initialize.apply(this);
        this.get("collectionEventAggregator").unbind("selectedItem:changed", this.selectedItemChangedEventHandler);
        this.get("collectionEventAggregator").bind("selectedItem:changed",   this.selectedItemChangedEventHandler,                         this);
      },

      addPackageDetails : function()  {
        var fetchedPackages         = this.get("fetchedPackages"),
            selectedPackageClassId  = this.get("packageClassId"),
            selectedPackages        = _.filter(fetchedPackages, function(iterablePackage) {
              return  iterablePackage.packageClassId === selectedPackageClassId;
            }),
            selectedPackage         = selectedPackages.length>0 ? selectedPackages[0] : undefined;

        if (selectedPackage)
          _.extend(this.attributes, selectedPackage);
      },

      addAccessoryDetails : function(){
        var fetchedAccessories      = this.get("fetchedAccessories"),
            selectedPackageClassId  = this.get("accessory") ? this.get("accessory").packageClassId : undefined,
            selectedPackages        = _.filter(fetchedAccessories, function(iterablePackage) {
              return  iterablePackage.packageClassId === selectedPackageClassId;
            }),
            selectedPackage         = {
              accessory : selectedPackages.length>0 ? selectedPackages[0] : undefined
            };

        if (selectedPackage)
          _.extend(this.attributes, selectedPackage);
        this.trigger("render:requested");
      },

      fetchPackages   : function()  {
        var that                                    = this,
            //Defining race conditions variables
            powerSupplyDataFetchCompleted           = false,
            accessoryDataFetchCompleted             = false,
            i                                       = 0;

        //Race condition check
        var checkRaceCondition                      = function() {
          if( powerSupplyDataFetchCompleted && accessoryDataFetchCompleted)
            that.trigger("packages:fetched");
        };

        //Data products retrieval
        var retrieveProductData                     = function(data, confirmCondition) {
          var fetchedPackages       = data.packages,
              fetchedPackagesLength = fetchedPackages.length;

          var getProducts         = function(originalPackage) {
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(originalPackage.packageClassId, function(data){
              var mainProduct       = _.filter(data.products,function(product)    {return (product.mnemonic===1);})[0];
              var secondaryProducts = _.filter(data.products,function(product)    {return (product.mnemonic!==1);});

              _.extend(originalPackage, mainProduct);
              originalPackage.secondaryProducts = secondaryProducts;

              if (confirmCondition) confirmCondition();
              checkRaceCondition();
            }, true);
          };

          for ( i=0; i<fetchedPackagesLength; i++ )
          {
            if  ( fetchedPackages[i].specialVars  &&  fetchedPackages[i].specialVars!==""  &&  typeof(fetchedPackages[i].specialVars)!=="object" )
              fetchedPackages[i].specialVars = JSON.parse(fetchedPackages[i].specialVars);

            getProducts(fetchedPackages[i]);
          }

          return fetchedPackages;
        };

        //Defining success callbacks
        var powerSupplyPackageFetchSuccessCallback  = function(data) {
          that.attributes.fetchedPackages    = retrieveProductData(data, function() {powerSupplyDataFetchCompleted = true;});
        };

        //Defining success callbacks
        var accessoryPackageFetchSuccessCallback    = function(data) {
          that.attributes.fetchedAccessories = retrieveProductData(data, function() {accessoryDataFetchCompleted   = true;});
        };

        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(804, powerSupplyPackageFetchSuccessCallback,  undefined, true);
        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(805, accessoryPackageFetchSuccessCallback,    undefined, true);
      },

      addItem                         : function(itemModel) {
        var collection                 = this.get("collection"), collectionLength = collection.length;
        var defaultItem;

        var collectionItemModel = genericCollectionItem.Model;

        if (itemModel)
          defaultItem         = new collectionItemModel(itemModel);
        else
          defaultItem         = new collectionItemModel({fetchedPackages : this.get("fetchedPackages"), fetchedAccessories : this.get("fetchedAccessories"), number : this.getNewNumber(), collectionEventAggregator : this.get("collectionEventAggregator")});

        var itemsToAdd        = [];
        itemsToAdd.push(defaultItem);
        if (genericCollectionSection.Model.prototype.addItem.apply(this, itemsToAdd))
        {
          defaultItem.set("selected", true);
          this.trigger("updateViews", this.get("collection").length);

          //Trigger event for zone validation
          this.trigger("item:added");

          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          this.sortItems();
          return defaultItem;
        }
      },

      duplicateSelectedItem           : function() {
        var collectionItemModel        = genericCollectionItem.Model;
        var itemNumber                 = this.getNewNumber(), modelToDuplicate;
        var selectedModels             = this.get("collection").filter(function(item){return item.get("selected");});

        var collection                 = this.get("collection"), collectionLength = collection.length;

        if (selectedModels.length>0 && collection.length + 1 <= this.get("maxItem"))
        {
          modelToDuplicate = new collectionItemModel(selectedModels[0].attributes);
          if (modelToDuplicate)
          {
            modelToDuplicate.set("number", itemNumber);
            this.get("collection").add(modelToDuplicate);
            this.trigger("updateViews", this.get("collection").length);

            selectedModels[0].set("selected", false);
            modelToDuplicate.set("selected", true);

            //Trigger event for zone validation
            this.trigger("item:added");

            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            this.sortItems();
            return modelToDuplicate;
          }
          else
            return false;
        }
        else
        {
          alert($.i18n._('IDS_W1_9128'));
          return false;
        }
      },

      removeSelectedItem              : function() {

        var selectedModels      = this.get("collection").filter(function(item){
          return item.get("selected");
        });

        if (selectedModels.length>0)
        {
          if (this.deleteItem(selectedModels))
          {
            this.trigger("updateViews", this.get("collection").length);

            //Trigger event for zone validation
            this.trigger("item:removed");

            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            this.sortItems();
            return selectedModels[0];
          }
        }
        else
          return false;
      },

      sortItems                       : function() {
        var collection = this.get("collection"), collectionLength = collection.length;
        var i=0;

        for (i=0; i<collectionLength; i++)
        {
          collection.models[i].set("number", (i+1));
          if (i===(collectionLength-1))
            collection.models[i].set("selected", true);
          else
            collection.models[i].set("selected", false);
        }
      },

      deliverCurrent  : function()  {
        var collection                  = this.get("collection"), collectionLength = collection.length;
        var consumptionIndicatorModel   = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
        var extraConsumption            = 30; //30 mA of extra consumption
        var mustDeliverExtraConsumption = false;
        var i=0;

        //Delivering regular consumptions
        for (i=0; i<collectionLength; i++)
          collection.models[i].deliverCurrent();
      }
    }),
    genericCollectionItem   : genericCollectionItem
  });

  // Required, return the module for AMD compliance
  return logicArea;

});